module.exports = __webpack_public_path__ + "img/arrow-right.4fa0fc93.svg";